import EstimateSection from "./EstimateSection";

export default function EstimateTable({ sections = [], onToggleRowIncluded }) {
  if (!sections.length) {
    return (
      <div className="m-4 rounded-sm border border-[#edebe9] bg-white px-4 py-3 text-sm text-[#605e5c]">
        No rows
      </div>
    );
  }

  return (
    <div className="bg-white">
      {sections.map((section) => {
        const sectionKey = section.id || section.key || section.title;

        const hasSubSections =
          Array.isArray(section.sections) && section.sections.length > 0;

        if (hasSubSections) {
          return (
            <section key={sectionKey} className="border-b border-[#edebe9]">
              <div className="sticky top-0 z-[5] flex items-center justify-between border-b border-[#edebe9] bg-[#faf9f8] px-4 py-2">
                <h2 className="text-sm font-semibold text-[#201f1e]">
                  {section.title}
                </h2>

                <span className="text-xs text-[#8a8886]">
                  {section.sections.length} groups
                </span>
              </div>

              <div className="divide-y divide-[#edebe9]">
                {section.sections.map((subSection) => (
                  <EstimateSection
                    key={subSection.id || subSection.key || subSection.title}
                    section={subSection}
                    variant={subSection.variant}
                    onToggleRowIncluded={onToggleRowIncluded}
                  />
                ))}
              </div>
            </section>
          );
        }

        return (
          <EstimateSection
            key={sectionKey}
            section={section}
            variant={section.variant}
            onToggleRowIncluded={onToggleRowIncluded}
          />
        );
      })}
    </div>
  );
}